<template>
  <div class="dropdown-actions">
    <div class="dropdown-actions-button">
      <icon name="dots-vertical"/>
    </div>
    <ul>
      <slot></slot>
    </ul>
  </div>

</template>

<script>
    export default {
        name: 'FormField',
        props: ['value'],
        data: function () {
            return {
                internalValue: '',
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {

        },
        watch: {
            'value'(newVal, oldVal) {
              this.internalValue = newVal
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ActionsDropdown.vue